import { MbscResource } from '@mobiscroll/angular';
import { Workschema } from '../../types/workschema';

export interface LoadRosterDetailParams {
  date: string;
  employeeId: number;
}

export interface LoadRosterResourceParams {
  employeeId: number;
  begindate: string;
  enddate: string;
}

export abstract class RosterResourceRepository<T extends MbscResource, TDetail> {
  abstract load(params: LoadRosterResourceParams): Promise<T[]>;
  abstract loadDetail(params: LoadRosterDetailParams): Promise<TDetail>;

  loadWorkschema(_params: LoadRosterDetailParams): Promise<Workschema | null> {
    return Promise.resolve(null);
  }
}
